"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.triggerDTMEvent = void 0;
var _utils = require("acq-utils/lib/utils");
/* eslint no-underscore-dangle: 0 */
/* eslint no-console: 0 */

var generateDTMEventInfo = function generateDTMEventInfo(dtmObj) {
  return {
    eventInfo: {
      eventAction: dtmObj.eventAction,
      eventAsset: dtmObj.eventAsset,
      eventType: 'pageInteraction'
    }
  };
};
var triggerDTMEvent = exports.triggerDTMEvent = function triggerDTMEvent(dtmObj) {
  var isServerFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _utils.isServer;
  if (isServerFn() || !window.digitalData || !dtmObj || dtmObj.dtmIgnore || !dtmObj.eventAction || !dtmObj.eventAsset) {
    return;
  }
  window.digitalData.event = [];
  var dtmEvent = generateDTMEventInfo(dtmObj);
  window.digitalData.event.push(dtmEvent);
  if (window._satellite) {
    try {
      window._satellite.track('event');
    } catch (error) {
      console.log('window._satellite.track generated error: ', error);
    }
  }
};